module.exports = __webpack_public_path__ + "static/img/male-3.4917ded0.png";